import type { NodeDefinition } from '@shared/types/node-definition';

const definition: NodeDefinition = {
  type: 'langchain-text-splitter',
  name: 'LangChain Text Splitter',
  description: 'Split large text documents into smaller chunks for processing',
  icon: 'Scissors',
  color: 'purple',
  category: 'ai-nodes',
  tags: ['langchain', 'text', 'split', 'chunk', 'document'],
  comingSoon: true,
  version: '1.0.0',
  inputs: [],
  outputs: [],
};

export default definition;
